import React, { useState, useEffect, useContext } from "react";
import api from "../api"; // your axios instance
import { AuthContext } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";
import "./quoteform.css";
import { QuoteContext } from "./QuoteContext";
import { Link } from "react-router-dom"; 
const QuoteRequest = () => {
  useEffect(() => {
    document.title = "Quote Request | Workgear365";
  }, []);
  const { user } = useContext(AuthContext);
   const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY; // set in .env
   const [loadingMap, setLoadingMap] = useState(false);
  const { quoteItems, updateQuoteItems } = useContext(QuoteContext);
const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id:"",
    name: "",
    email: "",
    phone: "",
    company_name: "",
    address: "",
    street: "",
    city: "",
    state: "",
    zipcode: "",
    only_quote: false,
    imprinting_options: {
      lettering: [],
      logo_design: false,
      locations: [],
      positions: [],
      print_types: [],
      one_color_detail: "",
      two_color_1: "",
      two_color_2: "",
      lettering_details: [],
      lettering_required: "",
    },
    products: [],
    additional_notes: "",
    lettering_file: null,
    logo_file: null,
    design_image: null,
  });

  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  // Utility: load Google Maps script
  const loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps && window.google.maps.places) {
        resolve(window.google);
        return;
      }
      if (!GOOGLE_API_KEY) {
        reject(new Error("Google API key is not set. Put REACT_APP_GOOGLE_API_KEY in your .env"));
        return;
      }

      // Avoid injecting multiple script tags
      if (document.querySelector(`script[data-google="places"]`)) {
        const check = setInterval(() => {
          if (window.google && window.google.maps && window.google.maps.places) {
            clearInterval(check);
            resolve(window.google);
          }
        }, 100);
        return;
      }

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.setAttribute("data-google", "places");
      script.onload = () => {
        resolve(window.google);
      };
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });
  };
  // Prefill customer info and products from context/API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let products = [];
          products = quoteItems || [];
         setFormData((prev) => ({
          ...prev,
          id: user?.id || "",
          name: user?.name || "",
          email: user?.email || "",
          phone: user?.phone || "",
          company_name: user?.company_name || "",
          address: `${user?.address || ""},\n${user?.city || ""},\n ${user?.state || ""} ${user?.zip_code || ""}`.trim().replace(/^,|,$/g, ""),
         products: products.map((p) => ({
            ...p,
            sizeQty: {}, // for quantities
          })),
        }));
      } catch (err) {
        console.error("Failed to prefill products", err);
      }
    };

    fetchProducts();
  }, [user, quoteItems]);

  // Google Places Autocomplete for address (guest users)
  useEffect(() => {
  if (user) return; // only for guest users

  const initAutocomplete = async () => {
    try {
      setLoadingMap(true);
      const google = await loadGoogleMaps(); // 👈 Wait for script to load

      const streetInput = document.getElementById("street");
     
      const autocomplete = new google.maps.places.Autocomplete(streetInput, {
        types: ["address"],
        componentRestrictions: { country: "us" },
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const comp = place.address_components;

        let street = "", city = "", state = "", zip = "";
        comp.forEach((c) => {
          if (c.types.includes("street_number")) street = c.long_name + " " + street;
          if (c.types.includes("route")) street += c.long_name;
          if (c.types.includes("locality")) city = c.long_name;
          if (c.types.includes("administrative_area_level_1")) state = c.short_name;
          if (c.types.includes("postal_code")) zip = c.long_name;
        });

        setFormData((prev) => ({
          ...prev,
          street,
          city,
          state,
          zipcode: zip,
          address: `${street}\n${city}\n${state} - ${zip}`,
        }));
      });

      setLoadingMap(false);
    } catch (err) {
      console.error("Google Maps load error:", err);
      setLoadingMap(false);
    }
  };

  initAutocomplete();
}, [user]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Nested fields for imprinting options
    if (name.startsWith("imprinting_options")) {
      const keys = name.split(".");
      setFormData((prev) => {
        const updated = { ...prev };
        let obj = updated.imprinting_options;
        for (let i = 1; i < keys.length - 1; i++) obj = obj[keys[i]];
        const lastKey = keys[keys.length - 1];

        if (type === "checkbox") {
          if (Array.isArray(obj[lastKey])) {
            if (checked) obj[lastKey].push(value);
            else obj[lastKey] = obj[lastKey].filter((v) => v !== value);
          } else {
            obj[lastKey] = checked;
          }
        } else {
          obj[lastKey] = value;
        }
        return updated;
      });
    }
    // File inputs
    else if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: e.target.files[0] }));
    }
    // Checkbox outside imprinting options
    else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    }
    // Normal text/number inputs
    else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Update product quantity
  const handleProductQty = (index, size, value) => {
    setFormData((prev) => {
      const updated = { ...prev };
      updated.products[index].sizeQty[size] = Number(value);
      return updated;
    });
  };

  const validateForm = () => {
    const errs = [];
    if (!formData.name.trim()) errs.push("Name is required.");
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      errs.push("Valid email is required.");
    if (!formData.phone.trim()) errs.push("Phone is required.");
    if (!formData.address.trim()) errs.push("Address is required.");
    if (!formData.products.length) errs.push("At least one product is required.");
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (validationErrors.length) {
      setErrors(validationErrors);
      return;
    }

    setErrors([]);
    setSubmitting(true);

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "products" || key === "imprinting_options") {
        submitData.append(key, JSON.stringify(formData[key]));
      } else if (["lettering_file", "logo_file", "design_image"].includes(key)) {
        if (formData[key]) submitData.append(key, formData[key]);
      } else {
        submitData.append(key, formData[key]);
      }
    });

      const response = await api.post("/api/quotes/submit-quotes", submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 201) {
           // Redirect to success page
            updateQuoteItems([]);
          navigate("/quote-success");
        } else {
          alert("Failed to submit quote.");
        }
            
          };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
           
            <div className="text-center mb-4">
                <h1 className="text-danger fw-bold mb-3">Bulk / Imprinting Quote Request</h1>
                <p className="text-muted">Request a quote for bulk orders and custom imprinting services</p>
           </div>
      {errors.length > 0 && (
        <div className="alert alert-danger">
          <ul>{errors.map((err, i) => <li key={i}>{err}</li>)}</ul>
        </div>
      )}

      <form onSubmit={handleSubmit}>

        {/* Customer Section */}
        <div className="form-section">
          <h5><i className="fa-solid fa-user me-2"/> Customer Information</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Name *</label>
              <input type="hidden" name="uid" value={formData.id}  className="form-control" />
              <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Phone *</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Company</label>
              <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} className="form-control" />
            </div>
           {/* Address Section */}
            <div className="col-12 mb-3">
              <label className="form-label fw-bold">Address *</label>

              {user ? (
                // ✅ Logged-in user: show textarea only
                <textarea
                  name="address"
                  id="customerAddress"
                  className="form-control"
                  rows="3"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              ) : (
                // ❌ Guest user: show separate address fields
                <>
                
                  <input
                    type="text"
                    className="form-control mb-2"
                    id="street"
                    name="street"
                    placeholder="Street Address"
                    value={formData.street}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    className="form-control mb-2"
                    id="city"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    className="form-control mb-2"
                    id="state"
                    name="state"
                    placeholder="State"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    className="form-control mb-2"
                    id="zipcode"
                    name="zipcode"
                    placeholder="Zip Code"
                    value={formData.zipcode}
                    onChange={handleChange}
                    required
                  />
                  {/* Hidden combined address textarea */}
                  <textarea
                    name="address"
                    id="customerAddress"
                    className="d-none"
                    value={formData.address}
                    readOnly
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {/* Imprinting Section */}
        
        <div className="form-section">
           <div className="row">
              <div className="col-12 mb-3">
                <h5> <input type="checkbox" name="only_quote" value="only_quote" />  Bulk Quote Only (No Imprinting) </h5>
              </div>
          </div>
          <h5 ><i className="fa-solid fa-palette me-2" ></i>Imprinting Options</h5>
          {/* Lettering */}
          <div className="mb-4">
            <label className="form-label fw-bold">Lettering Options:</label>
            <div className="checkbox-group">
              <div className="checkbox-item">
                <input type="checkbox" name="imprinting_options.lettering" value="lettering_only" checked={formData.imprinting_options.lettering.includes("lettering_only")} onChange={handleChange} />
                <label>Lettering</label>
              </div>
              <div className="checkbox-item">
                <input type="checkbox" name="imprinting_options.logo_design" checked={formData.imprinting_options.logo_design} onChange={handleChange} />
                <label>Logo Design</label>
              </div>
            </div>
          </div>

          {/* Locations */}
          <div className="mb-4">
            <label className="form-label fw-bold">Lettering Positions:</label>
            <div className="checkbox-group">
              {["front_left_chest","front_right_chest","front_center","back_center","sleeve","collar"].map((pos) => (
                <div key={pos} className="checkbox-item">
                  <input type="checkbox" name="imprinting_options.locations" value={pos} checked={formData.imprinting_options.locations.includes(pos)} onChange={handleChange} />
                  <label>{pos.replace(/_/g, " ")}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <label className="form-label fw-bold"> Logo Positions:</label>
            <div className="checkbox-group">
              {["front_left_chest","front_right_chest","front_center","back_center","sleeve","collar"].map((pos) => (
                <div key={pos} className="checkbox-item">
                  <input type="checkbox" name="imprinting_options.positions" value={pos} checked={formData.imprinting_options.positions.includes(pos)} onChange={handleChange} />
                  <label>{pos.replace(/_/g, " ")}</label>
                </div>
              ))}
            </div>
          </div>
          {/* Color Details Section */}
<div className="mb-4">
  <label className="form-label fw-bold">Color Details:</label>
  <div className="checkbox-group">
    {["one_color", "two_color", "full_color"].map((type) => (
      <div key={type} className="checkbox-item">
        <input
          type="checkbox"
          name="imprinting_options.print_types"
          value={type}
          id={type}
          checked={formData.imprinting_options.print_types.includes(type)}
          onChange={handleChange}
        />
        <label htmlFor={type}>
          {type === "one_color"
            ? "One Color Print"
            : type === "two_color"
            ? "Two Color Print"
            : "Full Color Print"}
        </label>
      </div>
    ))}
  </div>

  <div className="row mt-3">
    {/* One Color Specification */}
    {formData.imprinting_options.print_types.includes("one_color") && (
      <div className="col-md-6 mb-3">
        <label className="form-label">One Color Specification</label>
        <input
          type="text"
          className="form-control"
          name="imprinting_options.one_color_detail"
          value={formData.imprinting_options.one_color_detail}
          onChange={handleChange}
          placeholder="Specify color (e.g., Red, Blue, Black)"
        />
      </div>
    )}

    {/* Two Color Specification */}
    {formData.imprinting_options.print_types.includes("two_color") && (
      <div className="col-md-6 mb-3">
        <label className="form-label">Two Color Specification</label>
        <div className="row">
          <div className="col-6">
            <input
              type="text"
              className="form-control"
              name="imprinting_options.two_color_1"
              value={formData.imprinting_options.two_color_1}
              onChange={handleChange}
              placeholder="First color"
            />
          </div>
          <div className="col-6">
            <input
              type="text"
              className="form-control"
              name="imprinting_options.two_color_2"
              value={formData.imprinting_options.two_color_2}
              onChange={handleChange}
              placeholder="Second color"
            />
          </div>
        </div>
      </div>
    )}
  </div>
</div>
          {/* Lettering Options Details */}
            <div className="mb-4">
              <label className="form-label fw-bold">Lettering Options:</label>
              <div className="checkbox-group">
                {[
                  { value: "lettering_one_line", label: "One Line" },
                  { value: "lettering_two_line", label: "Two Line" },
                  { value: "lettering_three_line", label: "Three Line" },
                  { value: "lettering_four_line", label: "Four Line" },
                  { value: "lettering_arc", label: "Arc" },
                  { value: "block_style", label: "Block Style" },
                  { value: "script_style", label: "Script Style" },
                ].map((item) => (
                  <div key={item.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      name="imprinting_options.lettering_details"
                      value={item.value}
                      checked={formData.imprinting_options.lettering_details.includes(item.value)}
                      onChange={handleChange}
                      id={item.value}
                    />
                    <label htmlFor={item.value}>{item.label}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* Print Types */}
            <div className="mb-4">
              <label className="form-label fw-bold">Print Types:</label>
              <div className="checkbox-group">
                {[
                  { value: "heat_transfer", label: "Heat Transferred Print (Best for small quantities and multiple colors)" },
                  { value: "silk_screen", label: "Silk Screened Print (Best for over 30 pcs. and 1 to 2 colors)" },
                  { value: "embroidery", label: "Embroidery" },
                ].map((item) => (
                  <div key={item.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      name="imprinting_options.print_types"
                      value={item.value}
                      checked={formData.imprinting_options.print_types.includes(item.value)}
                      onChange={handleChange}
                      id={item.value}
                    />
                    <label htmlFor={item.value}>{item.label}</label>
                  </div>
                ))}
              </div>
            </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Lettering Required:</label>
            <textarea name="imprinting_options.lettering_required" value={formData.imprinting_options.lettering_required} onChange={handleChange} className="form-control" rows="3" placeholder="Enter text required" />
          </div>
        </div>

        {/* File Upload */}
        <div className="form-section">
          <h5><i className="fa-solid fa-upload me-2"></i>Design Files</h5>
          <div className="file-upload-section">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">Lettering File:</label>
                  <input type="file" name="lettering_file" onChange={handleChange} accept=".eps,.pdf,.ai" className="form-control" />
                  <small className="text-muted">Accepted formats: EPS, PDF, AI (Max size: 10MB)</small>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">Logo File:</label>
                  <input type="file" name="logo_file" onChange={handleChange} accept=".eps,.pdf,.ai" className="form-control" />
                  <small className="text-muted">Accepted formats: EPS, PDF, AI (Max size: 10MB)</small>
                </div>
             </div>
          <div className="row">
              <div className="col-12">
                <label className="form-label fw-bold">Design Image:</label>
                <input type="file" name="design_image" onChange={handleChange} accept="image/*" className="form-control" />
                <small className="text-muted">Accepted formats: JPG, PNG, GIF (Max size: 5MB)</small>
             </div>
          </div>
        </div>
      </div>    
       {/* Additional Notes */}
        <div className="form-section">
          <h5>Additional Notes</h5>
          <textarea name="additional_notes" value={formData.additional_notes} onChange={handleChange} className="form-control" rows="4" />
        </div>         
        {/* Products Section */}
        <div className="form-section">
          <h5><i className="fa-solid fa-box me-2"></i>Product Information</h5>
          {formData.products && formData.products.length > 0 ? (
            formData.products.map((prod, i) => (
              <div className="product-display" key={i}>
                <h6>Selected Product:</h6>
                <div className="product-info mb-3 p-2 border rounded">
                  <div><strong>Brand:</strong> {prod.brand}</div>
                  <div><strong>Style:</strong> {prod.style}</div>
                  <div><strong>Title:</strong> {prod.product?.details?.Title || prod.product_name}</div>
                  <div><strong>Color:</strong> {prod.color}</div>
                  <div><strong>Price:</strong> ${prod.product?.salePrice}</div>
                 </div>
                  {/* Quantity Section */}
                  <div className="row col-sm-12">
                    <small className="text-muted">
                      Please enter quantities for this style, color, and size selection:
                    </small>
                    <label className="form-label fw-bold mt-2">Quantity Needed *</label>

                    {prod.selected_sizes && prod.selected_sizes.length > 0 ? (
                      prod.selected_sizes.map((s) => (
                        <div className="col-md-2 mb-3" key={s}>
                          <label className="fw-semibold">{s}</label>
                          <input
                            type="number"
                            min="1"
                            max="5000"
                            className="form-control"
                            required
                            value={prod.sizeQty[s] || 1} // from state
                            onChange={(e) => handleProductQty(i, s, e.target.value)} // update state               
                          />
                        </div>
                      ))
                    ) : (
                      <div className="text-muted">No sizes selected.</div>
                    )}
                  </div>
                </div>
             
            ))
          ) : (
            <div className="alert alert-info">
              <i className="fa-solid fa-info-circle me-2"></i>
              No product selected. Please browse our catalog and select a product to get a quote.
              <Link to="/" className="btn btn-sm btn-primary ms-2">Browse Products</Link>
            </div>
          )}

        </div>
        
       

        {/* Submit */}
        <div className="text-center mt-3">
           <p><strong> Note: </strong>If you want to keep adding products to this quote request with the same imprinting 
                   requirements please continue to browse and add them to this quote request.
                    Once You Click "Submit Quote" the quote request will be finalized. 
                    Then if you want to add more products with different printing requirements
                     you can start another quote request on the product detail page. <br></br>
                   </p>
                   <Link to="/" className="btn btn-lg btn-primary ms-2 me-2">Continue Browsing To Add More Products</Link>
          <button type="submit" className="btn btn-success btn-lg" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Quote"}
          </button>
        </div>
      </form>
     </div>
    </div>
  </div>
 
  );
};

export default QuoteRequest;
